// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3a3Zp","subheader":"ReorderModal_subheader__3xFe4","listWrap":"ReorderModal_listWrap__35XQG"};